import BaseBarGroup from "./private/BaseBarGroup.js";
import AnimatedBars from "./private/AnimatedBars.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnimatedBarGroup(props) {
  return /*#__PURE__*/_jsx(BaseBarGroup, {
    ...props,
    BarsComponent: AnimatedBars
  });
}